import { getAdoptableWidgetConfig } from './ShopAll/AdoptableSlider/widgetConfig';
import { getCommissionWidgetConfig } from './ShopAll/CommissionSlider/widgetConfig';
import { getPremiumContentWidgetConfig } from './ShopAll/PremiumContentSlider/widgetConfig';
import { getPremiumFolderWidgetConfig } from './ShopAll/PremiumFolderSlider/widgetConfig';
import getCoverDeviationWidgetConfig from '../../UserWidgets.deviation_gruser/CoverDeviation/widgetConfig';

export const getShopWidgetConfigs = ({ t, dispatch }) => ({
  coverDeviation: getCoverDeviationWidgetConfig({ t, dispatch }),
  commissions: getCommissionWidgetConfig({ t, dispatch }),
  adoptables: getAdoptableWidgetConfig({ t, dispatch }),
  premiumContent: getPremiumContentWidgetConfig({ t, dispatch }),
  premiumFolders: getPremiumFolderWidgetConfig({ t, dispatch }),
});
